import { render, staticRenderFns } from "./PopUpDialog.vue?vue&type=template&id=2d4037b2"
import script from "./PopUpDialog.vue?vue&type=script&lang=js"
export * from "./PopUpDialog.vue?vue&type=script&lang=js"
import style0 from "./PopUpDialog.vue?vue&type=style&index=0&id=2d4037b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports